export const stepsData = [
    {
        id: 1,     
        title: 'Запись',   
        description: 'Позвоните по телефону +7 928 840 80 20 и администратор подберет удобное для Вас время приема ',
    },
    {
        id: 2,     
        title: 'Анкета',   
        description: 'Если Вы впервые в нашей клинике, Вам предложат заполнить анкету о здоровье, это важный шаг, которым не стоит пренебрегать, так как успех стоматологического лечения может зависеть от общих заболеваний организма   ',
    },
    {
        id: 3,     
        title: 'Консультация',   
        description: 'Консультация врача стоматолога включает комплексный осмотр, необходимые диагностические исследования и постановку диагноза ',
    },
    {
        id: 4,     
        title: 'План лечения',   
        description: 'Врач составляет подробный план лечения, в котором отражены все этапы, а также полная стоимость лечения, которая фиксируется на момент составления плана и не меняется  в процессе',
    },
    {
        id: 5,     
        title: 'Заключение договора и начало лечения',   
        description: 'Прежде чем начать лечение, мы заключаем договор, который является Вашей гарантией получения ожидаемого результата',
    },
]